/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../Containers/ArgosFlexbox"
import Html from "./Html"
import { useEffect, useState } from "react"


interface StaticReportProps {
  staticReportData: any
  reportId?: string
}

/**
 * Renders the StaticReport view for the selected report.
 * HTML sections are rendered dynamically based on the report's contents and format.
 */
const StaticReport = (props: StaticReportProps) => {
  const [staticReportData, setStaticReportData] = useState<any>(props.staticReportData)

  useEffect(() => {
    setStaticReportData(props.staticReportData)
  }, [props])

  return(
    <ArgosFlexbox vertical style={{flex: 1, overflow: 'auto', gap: "20px"}}>
      {/* <SyncStaticReport /> is called with HorizontalTabs "contentBelowTabNames" */}
      <Html htmlData={staticReportData}/>
    </ArgosFlexbox>
  )
}

export default StaticReport
